import { useState } from "react";
import { FilePreviewModal } from "dash-ui";

// TEMPORARY TYPE
type ProperyImageDisplayProps = {
  mainColor: string;
  images: {
    _id: string;
    files?: {
      _id: string;
      name?: string | undefined | null;
      publicUrl?: string | undefined | null;
      thumbnailFileUrl?: string | undefined | null;
    }[];
  }[];
};

// Component render layout based on images length
export function PropertyImageDisplay(props: ProperyImageDisplayProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const handleImageClick = (index: number) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const files = props.images
    .map((image) => image.files?.[0])
    .filter(Boolean)
    .map((file) => ({
      _id: file?._id || "",
      name: file?.name || "",
      publicUrl: file?.publicUrl || "",
      s3Key: file?.publicUrl || "",
      thumbnailFileUrl: file?.thumbnailFileUrl || "",
      type: "image/jpeg",
    }));

  return (
    <>
      {isModalOpen && (
        <FilePreviewModal
          isOpened={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          files={files}
          defaultIndex={modalIndex}
          isDownloadButtonVisible={false}
          isCentered={false}
          isExchange={true}
        />
      )}
      <div
        className="block sm:hidden relative"
        onClick={() => handleImageClick(0)}
      >
        <img
          src={files[0].thumbnailFileUrl}
          alt={files[0].name || ""}
          className="rounded-lg shadow-xl"
          style={{ borderColor: props.mainColor }}
        />
        <span
          className="absolute bottom-4 right-4 size-10 rounded-lg flex items-center justify-center text-white text-sm"
          style={{ backgroundColor: props.mainColor }}
        >
          1/{files.length}
        </span>
      </div>
      <div className="hidden sm:block">
        {props.images.length < 1 ? (
          <></>
        ) : props.images.length === 1 ? (
          <div className="h-96 w-full flex" onClick={() => handleImageClick(0)}>
            <img
              className="object-cover h-full w-full rounded shadow-lg cursor-pointer hover:scale-[1.02] transition-all"
              src={
                (props.images[0].files &&
                  props.images[0].files[0].thumbnailFileUrl) ||
                ""
              }
            />
          </div>
        ) : props.images.length === 2 ? (
          <div className="h-96 w-full grid grid-cols-2 gap-4">
            {props.images.slice(0, 2).map((image, idx) => (
              <img
                key={image._id}
                className="object-cover h-full w-full rounded shadow-lg cursor-pointer hover:scale-[1.02] transition-all"
                src={(image.files && image.files[0].thumbnailFileUrl) || ""}
                onClick={() => handleImageClick(idx)}
              />
            ))}
          </div>
        ) : props.images.length === 3 ? (
          <div className="h-96 w-full grid grid-cols-[2fr,1fr] grid-rows-2 gap-4">
            {props.images.slice(0, 3).map((image, idx) => (
              <img
                key={image._id}
                src={(image.files && image.files[0].thumbnailFileUrl) || ""}
                className={`object-cover h-full w-full rounded shadow-lg cursor-pointer hover:scale-[1.02] transition-all ${
                  idx === 0 ? "row-span-2" : ""
                }`}
                onClick={() => handleImageClick(idx)}
              />
            ))}
          </div>
        ) : props.images.length === 4 ? (
          <div className="h-96 w-full grid grid-cols-2 grid-rows-2 gap-4">
            {props.images.slice(0, 4).map((image, idx) => (
              <img
                key={image._id}
                src={(image.files && image.files[0].thumbnailFileUrl) || ""}
                className="object-cover h-full w-full rounded shadow-lg cursor-pointer hover:scale-[1.02] transition-all"
                onClick={() => handleImageClick(idx)}
              />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-[1fr,2fr,1fr] grid-rows-2 h-96 w-full gap-4">
            {props.images.slice(0, 5).map((image, idx) => (
              <div
                key={image._id}
                className={`relative ${
                  idx === 1 ? "row-span-2" : ""
                } cursor-pointer hover:scale-[1.02]`}
                onClick={() => handleImageClick(idx)}
              >
                {idx === 4 && props.images.length > 5 && (
                  <div
                    className="absolute h-full w-full bg-sky-600 bg-opacity-70 rounded flex items-center justify-center"
                    style={{ backgroundColor: props.mainColor, opacity: 0.7 }}
                  >
                    <span className="font-bold text-white text-4xl">
                      +{props.images.length - 5}
                    </span>
                  </div>
                )}
                <img
                  src={(image.files && image.files[0].thumbnailFileUrl) || ""}
                  className="object-cover h-full w-full rounded shadow-lg cursor-pointer hover:scale-[1.02] transition-all"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
